import { ProductScreenshot } from 'components/ProductScreenshot';
import * as React from 'react';
export default {
  ProductScreenshot,
  React
};